<template>
  <div class="field">
    <div class="field-dragging-ghost">
      <div class="js-drag-handle">
        <div class="field__ico-drag">
          <BaseIcon name="drag"/>
        </div>
      </div>
      <slot name="toggleBtn"></slot>
      <span class="field__label">{{ field.label }}</span>
      <span class="ghost__counter" v-if="field.children.length">{{ field.children.length }}</span>
    </div>
    <span class="field__key">
      <span>{{ field.key }}</span>
    </span>
    <span class="field__type"> {{ field.type }} </span>
    <div class="field__buttons">
      <BaseButton class="buttons__btn" title="Edit" @click.native="onEdit"/>
      <BaseButton class="buttons__btn" icon="trash" @click.native="onDelete"/>
      <BaseButton class="buttons__btn" icon="code" v-if="showCodeIcon" @click.native="onShowCode"/>
    </div>
  </div>
</template>

<script>
import { MDSModalEditFieldModel, MDSModalFieldCodeModel } from '@/models/modal-datasets.model'

export default {
  data () {
    return {
      isCollapsed: true
    }
  },
  props: {
    field: Object,
    scope: String,
    usedKeys: Array
  },
  computed: {
    hasChildrens () {
      return this.field.children.length
    },
    showCodeIcon () {
      return !(this.field.parent.type === 'repeater' || this.field.type === 'group' || this.scope === 'customobjectsgroups')
    }
  },
  methods: {
    toggleCollapse () {
      this.isCollapsed = !this.isCollapsed
    },
    onEdit () {
      const props = new MDSModalEditFieldModel({
        field: this.field,
        parent: this.field.parent,
        scope: this.scope,
        usedKeys: this.usedKeys
      })
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalEditField', props })
    },
    onDelete () {
      this.$emit('onDelete', { field: this.field, parent: this.field.parent })
    },
    onShowCode () {
      const props = new MDSModalFieldCodeModel({
        field: this.field,
        scope: this.scope,
      })
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalFieldCode', props })
    }
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/fonts.scss';
  @import './src/assets/styles/breakpoints.scss';

  $bp-first: 690px;
  $bp-second: 500px;

  .field-tree__branch {
    padding-left: 30px;
  }

  .field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    background-color: $color-white;
    border: 1px solid $color-border;
    margin: -1px -1px 0 -1px;

    div {
      display: flex;
      align-items: center;
    }

    &__ico-drag {
      padding: 25px 10px 25px 20px;
      cursor: move;
      cursor: -webkit-grabbing; /* stylelint-disable-line */

      svg {
        width: 6px;
        height: 10px;
      }
    }

    &__toggle-btn {
      position: relative;
      padding: 10px;
      user-select: none;
      cursor: pointer;
      
      svg {
        position: relative;
        z-index: 1;
        width: 9px;
        height: 10px;
        transform: rotateZ(-90deg);
        transition: transform .3s;
      }

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 35px;
        background-color: #ebf5fa;
        border-radius: 2px;
        opacity: 0;
        pointer-events: none;
        transform: translate(-50%, -50%);
        transition: opacity .15s;
      }

      &:hover {
        @include media(hover) {
          &:before {
            opacity: 1;
          }
        }
      }

      &:focus {
        outline: 2px solid $color-purple;
      }

      &--opened svg {
        transform: none;
      }
    }

    &__label {
      width: 100%;
      padding: 0 10px;
      color: $color-ebony-clay;
      font-size: 14.6px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__key {
      width: 20vw;
      margin-left: auto;

      @include media($bp-first) {
        display: none;
      }

      span {
        position: relative;
        z-index: 1;
        color: $color-pale-sky;
        font-family: $font-secondary;
        font-size: 12px;
        line-height: 1.67;

        &:before {
          content: '';
          position: absolute;
          top: -2px;
          right: -5px;
          bottom: -2px;
          left: -4px;
          z-index: -1;
          background-color: $color-porcelain;
          pointer-events: none;
        }
      }
    }

    &__type {
      width: 11vw;
      color: $color-pale-sky;
      font-family: $font-secondary;
      font-size: 12px;
      line-height: 1.67;

      @include media($bp-first) {
        margin-left: auto;
      }

      @include media($bp-second) {
        display: none;
      }
    }

    &__buttons {
      flex-shrink: 0;
      width: 116px;
      margin-left: 20px;

      .buttons__btn {
        border-radius: 0;
        margin-left: -1px;

        &:first-child {
          border-radius: 3px 0 0 3px;
        }

        &:last-child {
          border-radius: 0 3px 3px 0;
        }
      }
    }

    .field-dragging-ghost {
      position: relative;
      
      .dragging & {
        width: auto;
      }

      @include media($bp-second) {
        width: calc(100% - 136px);
      }
    }

    .ghost__counter {
      position: absolute;
      top: -5px;
      right: -35px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      background-color: $color-purple;
      border-radius: 50%;
      color: #fff;
      font-size: 14.7px;
      visibility: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Field.vue